var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEduYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 572,
    viewBox: "0 0 572 572",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325.007 242.861L332.262 240.509L314.072 184.409L306.817 186.761L325.007 242.861Z",
    fill: "#F7C869"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325.006 242.861L332.261 240.508L331.789 251.415L325.006 242.861Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M331.788 251.415L332.01 246.291L328.602 247.396L331.788 251.415Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M358.431 342.908V335.321H367.714V330.126H265.844V348.103H367.714V342.908H358.431Z",
    fill: "#8E681D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360.596 335.321H280.869V342.906H360.596V335.321Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M346.179 325.244V318.119H350.827V313.238H286V330.126H350.827V325.244H346.179Z",
    fill: "#F5B638"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M346.18 318.119H291.109V325.244H346.18V318.119Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M360.453 299.619L358.156 301.041L359.98 304.075L351.123 309.333L349.335 306.502L347.014 307.938L370.618 345.924L384.057 337.607L360.453 299.619Z",
    fill: "#8E681D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M359.98 304.075L359.983 304.078L351.123 309.333L370.168 339.981L378.924 334.561L359.98 304.075Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M440.684 361.879L440.684 345.771L254.001 345.771L254.001 361.879L440.684 361.879Z",
    fill: "#F7C869"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M448.735 266.271H432.631V506.084H448.735V266.271Z",
    fill: "#818181"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M339.08 266.271H322.977V506.084H339.08V266.271Z",
    fill: "#818181"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M482.58 274.325L482.58 258.217L186.851 258.217L186.851 274.325L482.58 274.325Z",
    fill: "#F7C869"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M482.582 506.084L482.582 489.977L199.81 489.977L199.81 506.084L482.582 506.084Z",
    fill: "#818181"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.756 506.083L214.756 489.976L193.813 489.976L193.813 506.083L214.756 506.083Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M491.375 506.084L491.375 489.976L470.432 489.976L470.432 506.084L491.375 506.084Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M381.466 421.164V472.853H363.355V439.233C363.355 429.254 371.464 421.164 381.466 421.164Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M499.957 421.164V472.853H518.068V439.233C518.068 429.254 509.96 421.164 499.957 421.164Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M462.893 329.398H455.221V310.796C455.221 302.846 448.738 296.377 440.768 296.377C432.799 296.377 426.317 302.846 426.317 310.796V329.398H418.645V310.796C418.641 298.625 428.567 288.724 440.767 288.724C452.967 288.724 462.893 298.625 462.893 310.796V329.398Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M506.084 472.853H375.451V385.613C375.451 349.627 404.694 320.452 440.769 320.452C476.841 320.452 506.086 349.625 506.086 385.613V472.853H506.084Z",
    fill: "#8E681D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M444.587 373.741H436.948C416.747 373.741 400.369 390.078 400.369 410.232V454.344H481.164V410.232C481.165 390.078 464.788 373.741 444.587 373.741Z",
    fill: "#F5B638"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M440.769 393.079C449.843 393.079 457.198 385.742 457.198 376.69C457.198 367.638 449.843 360.3 440.769 360.3C431.695 360.3 424.34 367.638 424.34 376.69C424.34 385.742 431.695 393.079 440.769 393.079Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M131.698 358.449H115.51V499.767H131.698V358.449Z",
    fill: "#818181"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1304 232.827V347.152C25.1304 357.565 33.5524 366.015 43.9603 366.045L125.269 366.275V382.47L38.7548 382.226C22.2743 382.181 8.93945 368.8 8.93945 352.313L8.94103 232.827H25.1304Z",
    fill: "#818181"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7688 366.219L51.6445 350.023L162.061 350.352V366.548L51.7688 366.219Z",
    fill: "#F7C869"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0921 318.206L24.9043 318.331L25.2332 210.278H41.421L41.0921 318.206Z",
    fill: "#F7C869"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7024 505.755L62.5781 489.561L181.319 489.888V506.084L62.7024 505.755Z",
    fill: "#818181"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M186.311 505.919L186.311 489.724L165.259 489.724L165.259 505.919L186.311 505.919Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9492 505.92L81.9492 489.725L60.8974 489.725L60.8974 505.92L81.9492 505.92Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9046 232.827H8.7168V253.889H24.9046V232.827Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M465.898 170.962L445.959 228.948L452.702 231.258L472.641 173.272L465.898 170.962Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M447.557 147.664L442.715 152.888L465.214 173.668L470.056 168.444L447.557 147.664Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M453.647 238.816H446.518V253.55H453.647V238.816Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M443.909 146.254H422.443V153.37H443.909V146.254Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M457.55 252.603H387.912V258.219H457.55V252.603Z",
    fill: "#F5B638"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M428.015 139.115C424.082 134.804 417.395 134.489 413.081 138.414L398.526 151.65L412.771 167.261L427.326 154.024C431.639 150.102 431.948 143.426 428.015 139.115Z",
    fill: "#8E681D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M415.384 164.865L401.158 149.276C389.991 143.435 375.916 144.791 366.065 153.75L365.734 154.051L407.329 199.633L407.66 199.331C417.512 190.373 420.172 176.509 415.384 164.865Z",
    fill: "#F5B638"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M457.55 226.958H442.215V241.849H457.55V226.958Z",
    fill: "#8E681D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M444.555 156.645C448.335 156.645 451.4 153.586 451.4 149.812C451.4 146.039 448.335 142.979 444.555 142.979C440.774 142.979 437.709 146.039 437.709 149.812C437.709 153.586 440.774 156.645 444.555 156.645Z",
    fill: "#F5B638"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M469.275 178.945C473.056 178.945 476.121 175.886 476.121 172.112C476.121 168.338 473.056 165.279 469.275 165.279C465.495 165.279 462.43 168.338 462.43 172.112C462.43 175.886 465.495 178.945 469.275 178.945Z",
    fill: "#F5B638"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M367.17 252.225H295.807V257.672H367.17V252.225Z",
    fill: "#818181"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M441.256 307.246C444.265 307.246 446.704 304.807 446.704 301.798C446.704 298.79 444.265 296.351 441.256 296.351C438.248 296.351 435.809 298.79 435.809 301.798C435.809 304.807 438.248 307.246 441.256 307.246Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M198.871 202.653C193.049 188.269 193.992 174.329 193.992 174.329C193.992 174.329 204.373 183.711 210.194 198.095C216.014 212.479 215.073 226.419 215.073 226.419C215.073 226.419 204.692 217.037 198.871 202.653Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M240.872 204.26C232.909 217.584 221.209 225.267 221.209 225.267C221.209 225.267 222.42 211.347 230.384 198.024C238.348 184.701 250.047 177.018 250.047 177.018C250.047 177.018 248.835 190.937 240.872 204.26Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M221.03 167.455C224.384 154.879 232.053 145.996 232.053 145.996C232.053 145.996 234.284 157.504 230.93 170.081C227.577 182.658 219.907 191.541 219.907 191.541C219.907 191.541 217.675 180.031 221.03 167.455Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M209.125 169.762C206.587 161.714 207.696 154.196 207.696 154.196C207.696 154.196 212.922 159.726 215.46 167.774C217.998 175.822 216.889 183.34 216.889 183.34C216.889 183.34 211.664 177.81 209.125 169.762Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M218.043 234.792C217.138 211.96 220.059 187.158 220.088 186.91L220.941 187.011C220.911 187.259 217.998 211.995 218.9 234.759L218.043 234.792Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M217.994 233.244C216.122 227.352 213.56 224.61 213.535 224.583L214.157 223.993C214.266 224.108 216.875 226.886 218.812 232.985L217.994 233.244Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M218.843 233.301L218.072 232.925C218.403 232.251 221.242 224.698 222.697 220.798L223.502 221.097C223.329 221.558 219.275 232.421 218.843 233.301Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M219.095 197.074C219.086 191.953 215.913 181.79 215.881 181.688L216.7 181.432C216.832 181.854 219.944 191.822 219.953 197.073L219.095 197.074Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M224.932 259.851H212.458C207.637 259.851 203.597 256.221 203.106 251.446L199.674 224.204H237.227L234.297 251.31C233.871 256.143 229.805 259.851 224.932 259.851Z",
    fill: "#F5B638"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M239.697 222.808H197.205V225.601H239.697V222.808Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduYellow);
export default __webpack_public_path__ + "static/media/eduYellow.8ad4464e52dcde365aa38c6106470b0a.svg";
export { ForwardRef as ReactComponent };